<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="printContactIcon" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption">{{ printContactType }}</v-list-item-subtitle>
      <v-list-item-title>{{ printContact }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading">
            <v-icon small>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>編集する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="remove">
            <v-list-item-avatar>
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>削除する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-select required
          v-model="form.type"
          label="連絡先の種類"
          item-text="label"
          item-value="value"
          :items="getContactTypeItems"
          :rules="rules.type"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field required
          v-model="form.contact"
          :label="currentContactInputLabel"
          :rules="currentContactInputRules"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutGuardiansContact',
  components: {
    AbtItemAvatar,
    UtilConfirmModal
  },
  props: [
    'gid',
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'contact',
        status: {
          loading: false
        }
      },
      meta: {
        contact: {
          icons: {
            phone: ['fal', 'fa-phone-office'],
            mobile: ['fal', 'fa-mobile-alt'],
            email: ['fal', 'fa-at']
          },
          labels: {
            phone: '固定電話',
            mobile: '携帯電話',
            email: 'Eメール'
          },
          inputLabels: {
            phone: '電話番号',
            mobile: '電話番号',
            email: 'メールアドレス'
          }
        }
      },
      form: {
        id: '',
        type: '',
        contact: ''
      },
      rules: {
        type: [
          v => !!v || '必須項目です'
        ],
        email: [
          v => !!v || '必須項目です',
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || '妥当なEメールではありません。'
          }
        ],
        phone: [
          v => !!v || '必須項目です',
          v => !/[^0-9]/.test(v) || '数字のみ入力有効です'
        ],
        mobile: [
          v => !!v || '必須項目です',
          v => !/[^0-9]/.test(v) || '数字のみ入力有効です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.id &&
        this.$props.data.type &&
        this.$props.data.contact
      ) {
        this.$set(this, 'form', {
          valid: true,
          id: this.$props.data.id,
          type: this.$props.data.type,
          contact: this.$props.data.contact
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? this.$props.data.id : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      if (
        this.$props.data &&
        this.$props.data.id &&
        this.$props.gid
      ) {
        this.$refs.confirm.open({
          title: '連絡先の削除',
          message: (
            this.$props.data &&
            this.$props.data.contact
          ) ? [
              'この連絡先を削除してもよろしいですか？',
              '<br/>',
              this.$props.data.contact
            ].join('') : '',
          callback: () => {
            console.log('delete')
            this.$set(this.config.status, 'loading', true)
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(this.$url.api + 'about/delete/contact', {
                id: this.$props.data.id,
                cid: this.$props.gid
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  this.$emit('emit', {
                    action: 'removeContact',
                    data: res.data.data.id ? res.data.data.id : ''
                  })
                }
              })
            })
          }
        })
      }
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['all'].concat((this.$props.data && this.$props.data.id) ? [this.$props.data.id] : []).includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.$props.data.id
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.$props.data.id
      )
    },
    printContactIcon () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.meta.contact.icons[this.$props.data.type]
      ) ? this.meta.contact.icons[this.$props.data.type].join(' ') : ''
    },
    currentContactInputLabel () {
      return (
        this.meta.contact.inputLabels[this.form.type]
      ) ? this.meta.contact.inputLabels[this.form.type] : ''
    },
    currentContactInputRules () {
      return (
        this.rules[this.form.type]
      ) ? this.rules[this.form.type] : []
    },
    printContactType () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.$mango.contacts[this.$props.data.type]
      ) ? this.$mango.contacts[this.$props.data.type] : ''
    },
    printContact () {
      return (
        this.$props.data &&
        this.$props.data.contact
      ) ? this.$props.data.contact : ''
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.birthplace
      )
    },
    getContactTypeItems () {
      return Object.keys(this.$mango.contacts).map(key => {
        return {
          label: this.$mango.contacts[key],
          value: key
        }
      }).filter(it => {
        return it.value !== 'email'
      })
    }
  }
}
</script>
